export default __webpack_public_path__ + "static/NBInternationalPro-Mono-500d9a42fdfce67686de4a864321b68e.eot";